import React from "react";

export interface IIconCity {}

export default function IconCity() {
  return (
    <svg
      className="h-6 w-6"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 6H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V10H3C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6ZM6 18H4V16H6V18ZM6 14H4V12H6V14ZM11 18H9V16H11V18ZM11 14H9V12H11V14ZM11 10H9V8H11V10ZM11 6H9V4H11V6ZM15 18H13V16H15V18ZM15 14H13V12H15V14ZM15 10H13V8H15V10ZM15 6H13V4H15V6ZM20 18H18V16H20V18ZM20 14H18V12H20V14ZM20 10H18V8H20V10Z"
        className="fill-brij-Peach"
      ></path>
    </svg>
  );
}
